module.exports = __webpack_public_path__ + "img/shoucang-null@3x.f1ed2339.svg";